var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashBoard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.026 3.78428L4.83935 9.38428C3.63935 10.3176 2.66602 12.3043 2.66602 13.8109V23.6909C2.66602 26.7843 5.18602 29.3176 8.27935 29.3176H23.7194C26.8127 29.3176 29.3327 26.7843 29.3327 23.7043V13.9976C29.3327 12.3843 28.2527 10.3176 26.9327 9.39761L18.6927 3.62428C16.826 2.31761 13.826 2.38428 12.026 3.78428Z",
    stroke: "#707070",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 23.9895V19.9895",
    stroke: "#707070",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashBoard);
export default __webpack_public_path__ + "static/media/dash_board.dc05d6381bc159b6e740de1e9df5395b.svg";
export { ForwardRef as ReactComponent };